<template>

  <div class="files-list">
    <toolbar medium>
      <template v-slot:head>
        {{ $t('files.attached-files') }}
      </template>

      <template v-slot:controls v-if="!readonly">
        <v-btn depressed small @click="upload()" :title="$t('files.upload')">
          <v-icon>attach_file</v-icon> {{ $t('files.upload') }}
        </v-btn>

        <v-btn depressed small @click="capture()" :title="$t('files.capture')" v-if="camera">
          <v-icon>camera_alt</v-icon> {{ $t('files.capture') }}
        </v-btn>
      </template>
    </toolbar>

    <div class="files-list__items" v-if="files.length">
      <file-preview v-for="file of files"
                    :key="file.id"
                    :file="file"
                    size="small"
                    @click="view(file)" />
    </div>

    <no-data medium v-if="!files.length">{{ $t('files.no-files') }}</no-data>
  </div>

</template>

<script>
  import FilePreview from './file-preview'
  import FileViewDialog from './file-view-dialog'
  import FileUploadDialog from './file-upload-dialog'
  import CameraDialog from './camera-dialog'
  import NoData from "../../shared/no-data";
  import Toolbar from "../../shared/toolbar";

  export default {
    name: 'files-list',

    props: [ 'files', 'readonly' ],

    computed: {
      camera () {
        return !!this.$store.state.mediaDevices.length
      }
    },

    methods: {
      async upload () {
        const result = await this.$dialog.showAndWait(FileUploadDialog, {})

        if (result)
          this.$emit('upload', result)
      },

      async capture () {
        const result = await this.$dialog.showAndWait(CameraDialog, { width: 600})

        if (result)
          this.$emit('upload', result)
      },

      async view (file) {
        const result = await this.$dialog.showAndWait(FileViewDialog, { file: file, width: 600})

        if (result && result.result === 'remove')
          this.$emit('remove', file.id)
      },
    },

    async mounted () {
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        const devices = await navigator.mediaDevices.enumerateDevices()
        this.$set(this.$store.state, 'mediaDevices', [...devices])
      }
    },

    components: {
      Toolbar,
      NoData,
      FilePreview
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';
  @import '../../../assets/responsive';

  .files-list {
    height: 100%;

    &__heading {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .v-btn {
        margin-left: $spacing-default;
      }
    }

    &__items {
      $size: 100px;

      display: grid;
      grid-template-columns: repeat(auto-fit, minmax($size * 1.5, 1fr));
      grid-gap: $spacing-default $spacing-default;
      margin-top: $spacing-default;

      .file {
        ::v-deep {
          img, .document {
            border-radius: $border-radius;
            height: $size;
            width: 100%;
          }

          img {
            object-fit: cover;
          }

          .document {
            border: 1px solid $color-gray;
            background-color: lighten($color-gray, 5%);
          }
        }
      }
    }
  }

</style>
